import React, { useState } from 'react';
import { Button, Result } from 'antd';
import NodeModalReadCSV from '../../../components/react-flow/flow-builder-form/read/NodeModalReadCSV';
import NodeModalReadCsvAws from '../../../components/react-flow/flow-builder-form/read/NodeModalReadCsvAws';
import NodeModalReadPostgres2 from '../../../components/react-flow/flow-builder-form/read/NodeModalReadPostgres2';
import NodeModalReadCSVAzure from '../../../components/react-flow/flow-builder-form/read/NodeModalReadCSVAzure';

const componentMap = {
  ReadCSV: NodeModalReadCSV,
  ReadCSVAws: NodeModalReadCsvAws,
  ReadPostgres2: NodeModalReadPostgres2,
  ReadCSVAzure: NodeModalReadCSVAzure
};

function ReadFormComponent({ readNodeId, selectedReadBlock, dataModelformField, setDataModelformField }) {
  const { key, label } = selectedReadBlock;

  const CommonProps = {
    open: true,
    handleClose: () => {},
    nodeId: readNodeId,
    nodeName: key,
    nodes: {},
    edges: [],
    changeNodeName: () => {},
    setNodes: () => {},
    dataModel: true,
    dataModelformField,
    setDataModelformField,
  };

  const SelectedNodeComponent = componentMap[key];

  return (
    <div>
      <strong>{label}</strong>
      {SelectedNodeComponent ? (
        <SelectedNodeComponent {...CommonProps} />
      ) : (
        <Result status="warning" title="Please select a different read block." />
      )}
    </div>
  );
}

export default ReadFormComponent;
